import { schema } from 'normalizr'

export const sim = new schema.Entity('sims');

export const sims = [sim];
